import { atom } from 'jotai';

export const openCreateResourceModalAtom = atom<boolean>(false);
